import React from "react";
import "./pagination.scss";
import LeftIcon from "../../assets/icons/left.svg";
const Pagination = ({
  totalData,
  itemsPerPage,
  currentPage,
  handleApiCall,
  setCurrentPage,
}) => {
  const handleNextClick = () => {
    if (
      (currentPage + 1) * itemsPerPage ===
      Math.ceil(totalData / itemsPerPage) * itemsPerPage
    ) {
      setCurrentPage(currentPage + 1);
      handleApiCall(currentPage + 1, itemsPerPage);
    }
  };
  const handlePreviousClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      handleApiCall(currentPage - 1, itemsPerPage);
    }
  };
  return (
    <div className="pagination">
      <div
        className="border"
        onClick={() => handlePreviousClick()}
        disabled={currentPage === 1}
      >
        <img src={LeftIcon} alt="LeftIcon" />
      </div>
      <span>{(currentPage - 1) * itemsPerPage + 1}</span>
      <span>to </span>
      <span>
        {currentPage * itemsPerPage > totalData
          ? totalData
          : currentPage * itemsPerPage}
      </span>
      <span> of </span>
      <span>{totalData}</span>
      <div
        className="border"
        onClick={() => handleNextClick()}
        disabled={
          currentPage * itemsPerPage ===
          Math.ceil(totalData / itemsPerPage) * itemsPerPage
        }
      >
        <img src={LeftIcon} alt="RightIcon" />
      </div>
    </div>
  );
};
export default Pagination;
